import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import getAccountView from './getAccountView'
import useAccount from './useAccount'

export default function useAccountView() {
  const { account, accountLoading, handleChangeAccount, invalidateAccountCache } = useAccount()
  const accountViewLoading = accountLoading
  const { t } = useTranslation()
  const returnProps = useMemo(() => {
    const accountView = getAccountView(account, t)
    accountView.profile = account
    return {
      accountView,
      accountViewLoading,
      handleChangeAccount,
      invalidateAccountCache,
    }
  }, [account, accountViewLoading, handleChangeAccount, invalidateAccountCache, t])
  return returnProps
}
